import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { AddIcon } from '@treams/treams-icons';
import { Link } from '@treams/treams-routes';

const Container = styled(Flex)`
	border-radius: 5px;
	border: 1px dashed ${(props) => props.theme.colors.lightBlue};
	font-size: 16px;
	color: ${(props) => props.theme.colors.slateBlue};
	align-items: center;
	cursor: pointer;

	svg {
		display: block;
		width: 24px;
		height: 24px;

		* {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}

	&:hover {
		background: white;
		border-style: solid;

		&:active {
			background: ${(props) => props.theme.colors.whiteBlueLight};
		}
	}
`;

export function PlaceholderButton(props: { title: string; onClick?: () => void; to?: string }) {
	const container = (
		<Container p={3} onClick={props.onClick}>
			<Box mr={2} flexShrink={0} flexGrow={0}>
				<AddIcon />
			</Box>
			<Box>{props.title}</Box>
		</Container>
	);

	if (props.to) {
		return <Link to={props.to}>{container}</Link>;
	}

	return container;
}
